import React from 'react'
import { Typography } from 'antd'

import type { LntParagraphProps } from './types'

export const LntParagraph: React.FC<LntParagraphProps> = props => {
  return <Typography.Paragraph { ...props } />
}
